import { Injectable, computed, signal } from '@angular/core';

// sessionStorage (not localStorage): impersonation ends when the tab closes, so a
// forgotten session can't silently persist across browser restarts.
const STORAGE_KEY = 'impersonation.target';

/**
 * Holds the "act as" target for admin impersonation. When active, the
 * CalystaAPIInterceptor attaches the X-Impersonate-Email header to every API call
 * and the backend runs the request as that user (admin-gated + audited server-side).
 */
@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private readonly _target = signal<string | null>(sessionStorage.getItem(STORAGE_KEY));

  readonly targetEmail = this._target.asReadonly();
  readonly isActive = computed(() => !!this._target());

  /** Email sent in the impersonation header, or null when not impersonating. */
  get header(): string | null {
    return this._target();
  }

  start(email: string): void {
    if (!email) return;
    sessionStorage.setItem(STORAGE_KEY, email);
    this._target.set(email);
    // Full reload so every cached grid / store refetches under the new identity.
    window.location.reload();
  }

  stop(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    this._target.set(null);
    window.location.reload();
  }
}
